<template>
    <section id="Form" class="Form blue-grey lighten-5">
        <div class="row container">
            <div class="col s12 m12 l10 offset-l1">
                <div class="more-sermons-heading">Reserve Your Seat</div>
                <p>
                    Due to COVID-19 we are holding services at a limited capacity. If you would like to attend, please reserve your spot by filling out the form. If you can't attend, you can view our live stream
                    <router-link :to="{name: 'sermons'}">here</router-link>.
                </p>
                <div class="card-panel sunday white">
                    <ValidationObserver v-slot="{ handleSubmit, reset }">
                        <form @submit.prevent="handleSubmit(onSubmit)" @reset.prevent="reset">
                            <div class="input-field col s12 m12 l6">
                                <div class="heading">Next Service</div>
                                <div class="date">Sunday - {{nextSundayDate}}</div>
                                <div>Select a time below:</div>
                                <ValidationProvider rules="required" v-slot="{ errors }">
                                    <span class="error-msg">{{ errors[0] }}</span>
                                    <p v-for="(service, index) in services" :key="index">
                                        <label class="service-time-label">
                                            <input name="service-time" class="with-gap" type="radio" v-model="form.ServiceID" :value="service.ServiceID" :disabled="(parseInt(service.CurrentReserved) >= parseInt(service.MaxCapacity)) || isDisabled ? 'disabled' : false"/>
                                            <span class="start-time">{{service.StartTime}}</span>
                                            <span class="capacity-under" v-if="parseInt(service.CurrentReserved) < parseInt(service.MaxCapacity)">
                                                Capacity: <span class="capacity-current">{{service.CurrentReserved}}</span> / {{service.MaxCapacity}}
                                            </span>
                                            <span class="capacity-over" v-if="parseInt(service.CurrentReserved) >= parseInt(service.MaxCapacity)">
                                                Closed - Capacity Reached
                                            </span>
                                        </label>
                                    </p>
                                </ValidationProvider>
                            </div>
                            <div class="col s12 m12 l6 form-border">
                                <div class="input-field col s12 m12">
                                    <ValidationProvider rules="required" v-slot="{ errors }">
                                        <label for="Name" class="active">Name *</label>
                                        <input id="Name" type="text" class="validate" v-model="form.Name" :disabled="isDisabled ? 'disabled' : false" maxlength="75" oninput="javascript: if (this.value.length > this.maxlength) this.value=this.value.slice(0,this.maxlength);"/>
                                        <span class="error-msg">{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </div>
                                <div class="input-field col s12 m8">
                                    <ValidationProvider rules="required|phone" v-slot="{ errors }">
                                        <label for="Phone" class="active">Phone *</label>
                                        <input id="Phone" type="text" class="validate" v-model="form.Phone" :disabled="isDisabled ? 'disabled' : false" maxlength="10" oninput="javascript: if (this.value.length > this.maxlength) this.value=this.value.slice(0,this.maxlength);"/>
                                        <span class="error-msg">{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </div>
                                <div class="input-field col s12 m4">
                                    <ValidationProvider rules="required" v-slot="{ errors }">
                                        <label for="PartySize" class="active">Party Size *</label>
                                        <input id="PartySize" type="number" class="validate" v-model="form.PartySize" :disabled="isDisabled ? 'disabled' : false" maxlength="10" oninput="javascript: if (this.value.length > this.maxlength) this.value=this.value.slice(0,this.maxlength);"/>
                                        <span class="error-msg">{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </div>
                                <div class="input-field col s12 center">
                                    <div v-if="success == true" class="success">You have reserved your seat(s). See you soon!</div>
                                    <div v-if="submitError != ''" class="submit-error">{{submitError}}</div>
                                    <button v-if="success == false" class="waves-effect waves-light btn" type="submit">Reserve</button>
                                </div>
                            </div>
                            <div style="clear: both"></div>
                        </form>
                    </ValidationObserver>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import M from 'materialize-css';
import { required } from 'vee-validate/dist/rules';
import ReservationsService from '../../services/Reservations.js';

    extend('phone', value => {
        var patt = new RegExp(/^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im);
        if (value.length > 0) {
            if (!patt.test(value)) {
                return 'Enter a valid phone number.';
            }
            else {
                return true;
            }
        }
    });

    // Override the default message.
    extend('required', {
        ...required,
        message: 'Required'
    });

export default {
    name: "Form",
    components: { ValidationProvider, ValidationObserver },
        data: function() {
        return {
            form: {
                ServiceID: "",
                Name: "",
                Phone: "",
                PartySize: ""
            },
            isDisabled: false,
            success: false,
            services: [],
            nextSundayDate: "",
            submitError: ""
        }
    },
    created: function() {
        if (this.$route.params.phone) {
            this.form.Phone = this.$route.params.phone.replace("+", "");
        }

        if (this.$route.params.name) {
            this.form.Name = this.$route.params.name;
        }
    },
    mounted: function() {
        M.updateTextFields();
        var self = this;
        var refDate = new Date();
        refDate.setHours(0,0,0,0);
        refDate.setDate(refDate.getDate() + ((7-refDate.getDay())%7+0) % 7);

        var monthArray = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
        self.nextSundayDate = monthArray[refDate.getMonth()] + " " + refDate.getDate() + ", " + refDate.getFullYear();

        ReservationsService.get(refDate.getFullYear() + '-' + (refDate.getMonth() + 1) + '-' + refDate.getDate()).then(function(response) {
            self.services = response;
        })
    },
    methods: {
        onSubmit: function() {
            var self = this;
            self.submitError = "";
            self.isDisabled = true;
            self.success = false;
            const payload = self.form;
            ReservationsService.save(payload).then(function(response) {
                if (response.statusCode == 200) {
                    self.success = true;
                }
                else {
                    self.submitError = response.results.error;
                    self.isDisabled = false;
                }
            });
        }
    },
    computed: {
        // buttonDisabled: function() {
        //     if (this.form.Name == '' || this.form.Phone == "" || this.form.PartySize == '' || this.form.ServiceID == '') {
        //         return false;
        //     }
        //     else     {
        //         return true;
        //     }
        // }
    }
};
</script>

<style scoped>
    section {
        padding: 4.5rem 0rem 3.5rem 0rem;
    }

    .heading {
        font-size: 1rem;
        line-height: 1;
        text-transform: uppercase;
        margin-bottom: .25rem;
    }

    .title { 
        margin-bottom: 1rem;
    }

    .card-panel {
        position: relative;
    }
    
    .card-panel:hover {
        -webkit-box-shadow: 0 16px 24px 2px rgba(0,0,0,0.14), 0 6px 30px 5px rgba(0,0,0,0.12), 0 8px 10px -7px rgba(0,0,0,0.2);
        box-shadow: 0 16px 24px 2px rgba(0,0,0,0.14), 0 6px 30px 5px rgba(0,0,0,0.12), 0 8px 10px -7px rgba(0,0,0,0.2);
    }

    .start-time {
        width: 100px;
    }

    .button-div {
        margin-top: 2rem;
    }
    [type="radio"]:disabled+span {
        text-decoration: line-through;
    }

    button {
        /* line-height: 58px; */
        /* font-size: 1.25rem; */
        /* padding: 0px 50px; */
        background: rgba(91,124,138, .7);
    }

    /* .capacity-current {
        font-size: 1rem;
    } */
    /* .capacity-under, */
    .capacity-over {
        color: red;
    }
    button:hover {
        color: #fff;
        background: rgba(91,124,138, 1);
    }

    form .row {
        margin-bottom: 0;
    }

    form .title {
        color: #000000;
        font-size: 1.5rem;
    }

    form input, 
    form textarea {
        /* color: #ffffff; */
        font-size: 1.25rem;
        font-family: 'NewhouseDTCond-ExtBold';
    }

    .title { 
        float: left;
    }
    
    .close {
        color: #000;
        /* position: absolute;
        right: 2rem;
        top: 2rem; */
        cursor: pointer;
        float: right;
    }
    .input-field {
        margin-bottom: 0;
    }

    .input-field span.error-msg {
        color: red;
    }

    .submit-error {
        margin-bottom: .5rem;
        color: red;
    }
    .service-time-label {
        color: #000000;
    }
    .date {
        margin-bottom: .75rem;
        font-size: 1.75rem;
        line-height: 1.25;
        font-family: NewhouseDTCond-ExtBold;
    }

    .more-sermons-heading {
        margin-bottom: 1.25rem;
        font-size: 3rem;
        line-height: 1.25;
        font-family: NewhouseDT-ExtraLight;
        text-align: center;
    }

    [type="radio"]:checked+span:after, [type="radio"].with-gap:checked+span:after {
        background-color:rgba(91,124,138, 1);
    }

    [type="radio"]:checked+span:after, [type="radio"].with-gap:checked+span:before, [type="radio"].with-gap:checked+span:after {
        border: 2px solid rgba(91,124,138, 1);
    }
    .form-border {
        border-left: 2px solid rgba(160,160,160,0.2);
    }

    @media screen and (max-width: 993px) {
        .card-panel.sunday {
            min-height: initial;
        }

        .form-border {
            margin-top: .5rem;
            padding-top: .5rem;
            border-left: none;
            border-top: 2px solid rgba(160,160,160,0.2);
        }
    }
</style>